import { httpClient } from '@/infra/protocols/http';

export async function deleteProject(
  params: DeleteProjectService.Params,
): Promise<DeleteProjectService.Response> {
  return await httpClient.delete(`/v1/projetos/${params.projectId}`);
}

export namespace DeleteProjectService {
  export interface Params {
    projectId: string;
  }

  export type Response = void;
}
